// External Imports
import { useState } from "react";
import { MdClose } from "react-icons/md";

// Internal Imports
import LoadingSpinner from "../UI/LoadingSpinner";
import { requestAdminAPI } from "../../api/posh-api";
import Heading from "../UI/Heading";
import Modal from "../UI/Modal";
import DetailPair from "../UI/DetailPair";
import CustomerSelector from "./CustomerSelector";

/** ========================================================================
 * * MessageModal Component
 * This component renders a form to send a message to a customer.
 * ========================================================================== */

export default function MessageModal({
  open,
  setOpen,
  customerId,
  onComplete,
}) {
  // Initialize States
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState();
  const [message, setMessage] = useState("");

  /* ====================== SEND MESSAGE ====================== */
  const submitHandler = async () => {
    try {
      setLoading(true);
      if (!selected) throw new Error("Please select a customer.");
      if (!message?.trim())
        throw new Error(
          "Your message is empty. Please type a message before sending it to the customer."
        );
      await requestAdminAPI("send-message", {
        customerId: selected.id,
        message,
      });
      setMessage("");
      onComplete && onComplete();
      setOpen(false);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal lg:h-[50vh] text-sm">
        <Heading title="Send Message" isBackArrow={false}>
          <MdClose className="icon" onClick={() => setOpen(false)} />
        </Heading>
        <div className="grid gap-4">
          <div className="grid gap-4 lg:grid-cols-3">
            <div className="lg:col-span-2">
              <CustomerSelector selected={customerId} onSelect={setSelected} />
            </div>
            <DetailPair
              label="PHONE NUMBER"
              edit={open}
              loading={loading}
              inputOptions={{
                disabled: true,
                type: "tel",
                value: selected?.phone ?? "",
              }}
            />
          </div>

          <textarea
            type="text"
            id="message-modal-input"
            className="w-full form-input min-h-[20vh]"
            placeholder="Type message here..."
            required={true}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          {loading ? (
            <LoadingSpinner classes="w-8 h-8 text-yellow-600 mx-auto" />
          ) : (
            <div className="grid gap-4 md:flex md:space-x-2">
              <button
                type="button"
                className="w-full btn-secondary"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
              <div onClick={submitHandler} className="w-full btn-primary">
                Send
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
